import { useState } from "react";
import { useParams, useOutletContext, useSearchParams } from "react-router-dom";
import { Files as FilesIcon, Video as VideoIcon } from "lucide-react";
import FilesPanel from "@/components/FilesPanel";
import MediaPanel from "@/components/MediaPanel";

// ProjectFilesPage — Feb 2026.
//
// Two-tab layout inside a single page. The active tab is reflected in the URL
// (?tab=videos) so deep-linking from a notification or bookmark drops the user
// straight into the right view.

export default function ProjectFilesPage() {
  const { id } = useParams();
  const { project } = useOutletContext();
  const [params, setParams] = useSearchParams();
  const initial = params.get("tab") === "videos" ? "videos" : "files";
  const [tab, setTab] = useState(initial);

  const switchTab = (next) => {
    setTab(next);
    const p = new URLSearchParams(params);
    if (next === "videos") p.set("tab", "videos");
    else p.delete("tab");
    setParams(p, { replace: true });
  };

  const tabs = [
    { key: "files", label: "Files", icon: FilesIcon },
    { key: "videos", label: "Videos", icon: VideoIcon },
  ];

  return (
    <div className="max-w-screen-2xl mx-auto px-6 lg:px-10 py-8">
      <div className="mb-6 border-b border-zinc-800">
        <div className="flex gap-1" data-testid="project-files-tabs">
          {tabs.map(({ key, label, icon: Icon }) => {
            const active = tab === key;
            return (
              <button
                key={key}
                type="button"
                data-testid={`project-files-tab-${key}`}
                onClick={() => switchTab(key)}
                className={`px-4 py-2.5 -mb-px flex items-center gap-2 text-sm font-medium border-b-2 transition-colors ${
                  active
                    ? "border-amber-500 text-amber-400"
                    : "border-transparent text-zinc-500 hover:text-zinc-200"
                }`}
              >
                <Icon className="w-4 h-4" />
                {label}
              </button>
            );
          })}
        </div>
      </div>

      {tab === "files" && (
        <FilesPanel projectId={id} myRole={project?.my_role} />
      )}
      {tab === "videos" && (
        <MediaPanel projectId={id} projectName={project?.name} myRole={project?.my_role} />
      )}
    </div>
  );
}
